module.exports = __webpack_public_path__ + "img/bus_sidebar_img_6.ef36f3ea.svg";